(function () {
  'use strict';

  const roots = document.querySelectorAll('[data-diag16]');
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  roots.forEach(function (root) {
    const baseUrl = root.dataset.diag16Url || '#';
    const utmSource = 'diag16_lp';
    const utmMedium = 'cta';
    const utmCampaign = root.dataset.utmCampaign || 'goencha_16types_diagnosis';

    const buildUrl = function (ctaName) {
      if (!baseUrl || baseUrl === '#') return baseUrl;
      try {
        const url = new URL(baseUrl, window.location.origin);
        if (!url.searchParams.has('utm_source')) url.searchParams.set('utm_source', utmSource);
        if (!url.searchParams.has('utm_medium')) url.searchParams.set('utm_medium', utmMedium);
        if (!url.searchParams.has('utm_campaign')) url.searchParams.set('utm_campaign', utmCampaign);
        url.searchParams.set('utm_content', ctaName || 'diag16_lp');
        return url.toString();
      } catch (_) {
        return baseUrl;
      }
    };

    root.querySelectorAll('.js-diag16-cta').forEach(function (link) {
      const ctaName = link.dataset.cta || 'diag16_lp';
      const built = buildUrl(ctaName);
      if (built && built !== '#') link.href = built;

      link.addEventListener('click', function () {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'diag16_lp_cta_click',
          cta: ctaName
        });
      });
    });

    if (prefersReducedMotion || !('IntersectionObserver' in window)) {
      root.querySelectorAll('.diag16__reveal').forEach(function (el) {
        el.classList.add('is-visible');
        el.style.transitionDelay = '';
      });
      return;
    }

    root.classList.add('diag16--motion-ready');

    root.querySelectorAll('.diag16__section, .diag16__types-section').forEach(function (el) {
      el.classList.add('diag16__reveal');
    });

    root.querySelectorAll('.diag16__step-card').forEach(function (el, i) {
      el.classList.add('diag16__reveal');
      el.style.transitionDelay = (i * 90) + 'ms';
    });

    root.querySelectorAll('.diag16__type-card').forEach(function (el, i) {
      el.style.transitionDelay = (i * 28) + 'ms';
    });

    const observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        entry.target.style.transitionDelay = '';
        observer.unobserve(entry.target);
      });
    }, {
      rootMargin: '0px 0px -10% 0px',
      threshold: 0.08
    });

    root.querySelectorAll('.diag16__reveal').forEach(function (el) {
      observer.observe(el);
    });

    root.querySelectorAll('.diag16__faq-list details').forEach(function (details) {
      const summary = details.querySelector('summary');
      if (!summary) return;

      summary.addEventListener('click', function (event) {
        event.preventDefault();
        if (details.dataset.animating === 'true') return;

        const startHeight = details.offsetHeight;
        details.dataset.animating = 'true';
        details.style.overflow = 'hidden';

        let endHeight;
        if (details.open) {
          details.open = false;
          endHeight = details.offsetHeight;
          details.open = true;
        } else {
          details.open = true;
          endHeight = details.offsetHeight;
        }

        details.style.height = startHeight + 'px';

        const animation = details.animate(
          { height: [startHeight + 'px', endHeight + 'px'] },
          { duration: 240, easing: 'cubic-bezier(0.2, 0.8, 0.2, 1)' }
        );

        animation.onfinish = function () {
          if (startHeight > endHeight) details.open = false;
          details.style.height = '';
          details.style.overflow = '';
          delete details.dataset.animating;
        };

        animation.oncancel = animation.onfinish;
      });
    });
  });
})();
